class ApexThemeMotion {
  constructor() {
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.observer = null;
    this.header = null;
    this.onScroll = this.onScroll.bind(this);
  }

  init() {
    document.documentElement.classList.add('apex-js');
    this.initRevealElements(document);
    this.initHeader();

    document.addEventListener('shopify:section:load', (event) => {
      this.initRevealElements(event.target);
    });
  }

  initRevealElements(root) {
    const elements = root.querySelectorAll('[data-apex-reveal]:not([data-apex-ready])');

    if (!elements.length) return;

    if (this.reducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.dataset.apexReady = 'true';
        element.classList.add('apex-is-visible');
      });
      return;
    }

    if (!this.observer) {
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('apex-is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }

    elements.forEach((element) => {
      element.dataset.apexReady = 'true';
      this.observer.observe(element);
    });
  }

  initHeader() {
    this.header = document.querySelector('.section-header');
    if (!this.header) return;

    this.onScroll();
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  onScroll() {
    if (!this.header) return;
    this.header.classList.toggle('apex-header-scrolled', window.scrollY > 24);
  }
}

const apexThemeMotion = new ApexThemeMotion();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => apexThemeMotion.init(), { once: true });
} else {
  apexThemeMotion.init();
}
